import { render, staticRenderFns } from "./MobileDropdown.vue?vue&type=template&id=80bacf98&"
import script from "./MobileDropdown.vue?vue&type=script&lang=js&"
export * from "./MobileDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MobileDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports